(function (window) {

  /**
   * @class
   */
  const ViewBase = Class(
    /**
     * @lends {ViewBase#}
     */
    {
      /** @type {SectionRtu} */
      controller: null,
      /** @type {Object} */
      par: null,
      /**
       * @param {SectionRtu} controller
       * @param {Object} par
       * @private
       */
      __construct (controller, par) {
        this.controller = controller;
        this.par = par || {};
        this.draw();
        const toggle = document.querySelector('#header-wrapper');
        if (toggle) {
          mkE({
            tag: 'div',
            id: 'header-wrapper',
            els: [
              {
                tag: 'header',
                id: 'header',
                els: [
                  {
                    tag: 'div',
                    className: 'header-content',
                    els: [
                      {
                        tag: 'div',
                        className: 'header-top',
                        els: [
                          {
                            tag: 'div',
                            className: 'menu-logo',
                            els: [
                              { tag: 'span', id: 'logo' },
                              {
                                tag: 'span',
                                id: 'logo_dg',
                                els: [
                                  {
                                    tag: 'img',
                                    src: '/assets/images/logo-dg.svg',
                                    width: '89',
                                    height: '14',
                                    alt: 'Draugiem Group'
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }).replace(toggle);
        }

      },
      /** @abstract */
      draw () {
      }
    },
    mkE.Base
  );

  const ViewIntro = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view view__info',
          els: [
            {
              tag: 'h1',
              className: 'mb-4',
              innerHTML: 'QR kodu spēle <br><b>“Talantu ekspedīcija”</b><br> ir aizraujošs un izzinošs sacensību izaicinājums 9.-12. klašu skolēniem'
            },
            {
              tag: 'p',
              innerHTML: 'Tavs uzdevums ir atrast 30 QR kodus un atbildēt uz jautājumiem!'
            },
            {
              tag: 'p',
              className: 'info',
              text: 'ATRODI UN NOSKENĒ QR KODU, LAI UZZINĀTU JAUTĀJUMU!'
            }
          ]
        });
        this.controller.rpc.send('intro', {}, this._onLoad);
      },
      _onLoad (re) {
        if (re.error) {
          switch (re.error) {
            case 'closed':
              this.controller.navigateTo('closed');
              return;
            default:
              this.controller.navigateTo('error');
              return;
          }
        }
        this.controller.ready();
      }
    },
    ViewBase
  );

  const ViewClosed = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view',
          els: [
            {
              tag: 'h1',
              className: 'mb-4',
              innerHTML: 'QR kodu spēle  <b>“Talantu ekspedīcija”</b> ir aizraujošs un izzinošs sacensību izaicinājums 9.-12. klašu skolēniem'
            },
            {
              tag: 'div',
              els: [
                {
                  tag: 'p',
                  className: 'mb-2',
                  text: 'Spēle noslēgusies. '
                }
              ]
            }
          ]
        });
        this.controller.ready();
      }
    },
    ViewBase
  );

  const ViewError = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view',
          els: [
            {
              tag: 'h1',
              className: 'mb-5',
              text: this.par.errorTitle || `Sistēmas kļūda`
            },
            {
              tag: 'p',
              text: this.par.errorMessage || 'Mēģini vēlāk...'
            }
          ]
        });
        this.controller.ready();
      }
    },
    ViewBase
  );

  const ViewRegister = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view',
          els: [
            {
              tag: 'h1',
              className: 'mb-4',
              innerHTML: 'QR kodu spēle  <b>“Talantu ekspedīcija”</b> ir aizraujošs un izzinošs sacensību izaicinājums 9.-12. klašu skolēniem'
            },
            {
              tag: 'p',
              className: 'mb-5',
              innerHTML: 'Tavs uzdevums ir atrast 30 QR kodus (tie paslēpti skolā) un atbildēt uz jautājumiem!'
            },
            {
              tag: 'a',
              className: 'button button-pink d-block',
              text: 'Pieteikties',
              onclick: () => {
                this._drawGDPR();
              },
            }
          ]
        });
        this.controller.ready();
      },
      _drawGDPR () {
        clearNode(this.node);
        this.node = mkE({
          tag: 'div',
          className: 'container view view__gdpr',
          els: [
            {
              tag: 'h1',
              className: 'mb-4',
              innerHTML: 'Informācija par spēli  <b>“Talantu ekspedīcija”</b>'
            },
            {
              tag: 'p',
              className: 'mb-5',
              els: [
                { tag: 'h4', text: 'Organizatori:' },
                { tag: 'p', text: 'Spēli organizē SIA Roadgames sadarbībā ar VIAA.' },
                { tag: 'h4', text: 'Dalībnieki:' },
                { tag: 'p', text: 'Spēle ir paredzēta 9.-12. klašu skolēniem (dalībniekiem jābūt vismaz 13 gadiem).' },
                { tag: 'h4', text: 'Spēles norise:' },
                { tag: 'p', text: 'Spēle norisināsies no 14. līdz 28. aprīlim (ieskaitot).' },
                { tag: 'h4', text: 'Reģistrācija:' },
                {
                  tag: 'p',
                  els: [
                    'Reģistrējoties spēlei, jānorāda šāda informācija:',
                    { tag: 'br' },
                    {
                      tag: 'ul',
                      els: [
                        { tag: 'li', text: 'Vārds,' },
                        { tag: 'li', text: 'Uzvārds,' },
                        { tag: 'li', text: 'Skola,' },
                        { tag: 'li', text: 'Klase,' },
                        { tag: 'li', text: 'E-pasta adrese.' },
                      ]
                    },
                  ]
                },
                { tag: 'h4', text: 'Personas datu apstrāde:' },
                {
                  tag: 'p',
                  els: [
                    {
                      tag: 'ul',
                      els: [
                        {
                          tag: 'li',
                          text: 'Reģistrējoties Jūs piekrītat, ka Jūsu personas dati var tikt nodoti VIAA,'
                        },
                        {
                          tag: 'li',
                          text: 'VIAA var sazināties ar dalībniekiem pēc spēles beigām,'
                        },
                        {
                          tag: 'li',
                          innerHTML: 'Personas dati tiks glabāti līdz 1 mēnesim pēc spēles beigām.'
                        },
                      ]
                    },
                  ]
                },
                { tag: 'h4', text: 'Privātuma politikas saites:' },
                {
                  tag: 'p',
                  className: 'mb-5',
                  els: [
                    {
                      tag: 'ul',
                      els: [
                        {
                          tag: 'li',
                          els: [
                            'Roadgames Privātuma politika: ',
                            {
                              tag: 'a',
                              className: 'text-bold',
                              href: D.url('/privacy-policy'),
                              target: '_blank',
                              text: 'ŠEIT'
                            }
                          ]
                        },
                        {
                          tag: 'li',
                          els: [
                            'VIAA Privātuma politika: ',
                            {
                              tag: 'a',
                              className: 'text-bold',
                              href: 'https://www.viaa.gov.lv/lv/privatuma-politika',
                              text: 'ŠEIT',
                              target: '_blank',
                              attr: {
                                rel: 'nofollow'
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  tag: 'a',
                  className: 'button button-pink d-block mb-3',
                  text: 'Apstiprināt',
                  onclick: () => {
                    this._drawRegister();
                  },
                },
                {
                  tag: 'p',
                  className: 'small',
                  text: '*Spiežot \'\'Apstiprināt\'\' Jūs automātiski piekrītat šīs spēles lietošanas noteikumiem.'
                },
                {
                  tag: 'a',
                  className: 'scroll',
                  onclick: this._onClickScroll
                }
              ]
            }
          ]
        }).replace(this.node);
      },
      _onClickScroll (e) {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;

        const atBottom = (scrollTop + windowHeight) >= (docHeight - 1);

        if (atBottom) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: docHeight, behavior: 'smooth' });
        }
        toggleClassName(e.currentTarget, 'at-bottom', !atBottom);
      },
      _drawRegister () {
        clearNode(this.node);
        this.node = mkE({
          tag: 'form',
          className: 'container flex-column view view__register',
          onsubmit: this._onRegisterSubmit,
          attr: {
            novalidate: '',
          },
          els: [
            {
              tag: 'h1',
              text: 'Piesakies Kvadrātkodu izaicinājumā!'
            },
            {
              tag: 'div',
              className: 'fieldset mb-4',
              els: [
                this._inputName = new T.Form.Input({
                  caption: 'Vārds',
                  border: true,
                  attr: {
                    maxlength: 255
                  }
                }),
                { tag: 'br' },
                this._inputSurname = new T.Form.Input({
                  caption: 'Uzvārds',
                  border: true,
                  attr: {
                    maxlength: 255
                  }
                }),
                { tag: 'br' },
                this._inputSchool = new T.Form.Input({
                  caption: 'Skola, bibliotēka u.c.',
                  border: true,
                  attr: {
                    maxlength: 255
                  }
                }),
                { tag: 'br' },
                this._inputGrade = new T.Form.Input({
                  caption: 'Klase',
                  border: true,
                  attr: {
                    maxlength: 255
                  }
                }),
                { tag: 'br' },
                this._inputEmail = new T.Form.Input({
                  caption: 'E-pasta adrese',
                  border: true,
                  attr: {
                    maxlength: 255
                  }
                }),
              ]
            },
            this._inputSubmit = mkE({
              tag: 'button',
              type: 'submit',
              className: 'button button-pink',
              text: 'Sākt izaicinājumu'
            })
          ]
        }).replace(this.node);
        this.controller.rpc.send('registration', {}, this._onLoadRegistration);
      },
      _onLoadRegistration (re) {
        if (re.error) {
          switch (re.error) {
            case 'closed':
              this.controller.navigateTo('closed');
              return;
            default:
              this.controller.navigateTo('error');
              return;
          }
        }
      },
      _onRegisterSubmit (e) {
        e.preventDefault();
        this.controller.rpc.send(
          'register',
          {
            name: this._inputName.value(),
            surname: this._inputSurname.value(),
            school: this._inputSchool.value(),
            grade: this._inputGrade.value(),
            email: this._inputEmail.value(),
          },
          this._onRegister
        );
      },
      _onRegister: function (re) {
        if (re.error) {
          switch (re.error) {
            case 'already registered':
              // Continue
              break;
            case 'closed':
              this.controller.navigateTo('closed');
              return;
            case 'invalid data':
            default:
              this.controller.navigateTo('error');
              return;
          }
        }
        this.controller.navigateTo('question');
      },
    },
    ViewBase
  );

  const ViewQuestion = Class(
    {
      _answer: 0,
      draw () {
        this.code = this.controller.code;
        this.node = mkE({
          tag: 'div',
          className: 'view view__question flex-column'
        });
        D.loadingOverlay(this.node, { delay: true });
        this.controller.rpc.send('question', { code: this.code }, this._onLoadQuestion);
      },
      _onLoadQuestion (re) {
        this.question = re;
        D.removeLoadingOverlay(this.node);
        if (re.error) {
          switch (re.error) {
            case 'auth':
              this.controller.navigateTo('register');
              return;
            case 'closed':
              this.controller.navigateTo('closed');
              return;
            case 'invalid code':
            case 'invalid data':
            default:
              this.controller.navigateTo('error', {
                errorTitle: 'Nederīgs kods',
                errorMessage: 'Kaut kas nav pareizi...',
              });
              return;
          }
        }
        this._draw();
        this.controller.ready();
      },
      _draw () {
        clearNode(this.node);
        const q = this.question;
        const c = Number(q.count) + (q.hasAnswered ? 0 : 1);
        mkE.appendTypeElement(this.node, [
          {
            tag: 'div',
            className: 'header',
            els: [
              {
                tag: 'div',
                className: 'container',
                els: [
                  {
                    tag: 'img',
                    src: '/assets/images/rtu/coder.svg',
                    width: 30
                  },
                  {
                    tag: 'div',
                    els: [
                      {
                        tag: 'h1',
                        text: 'Talantu ekspedīcija'
                      },
                      {
                        tag: 'p',
                        text: `${c} no 30 jautājumiem`
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            tag: !q.hasAnswered ? 'form' : 'div',
            onsubmit: this._onSubmit,
            className: 'form container flex-column',
            els: [
              {
                tag: 'h2',
                className: 'mb-3 question ' + (q.hasAnswered ? 'expandable contracted' : ''),
                onclick: (e) => {
                  if (q.hasAnswered) {
                    toggleClassName(e.currentTarget, 'contracted');
                  }
                },
                els: [
                  { tag: 'div', text: q.question }
                ]
              },
              {
                tag: 'div',
                className: 'flex-column mb-2 answers',
                style: {
                  flexGrow: 0
                },
                els: (() => {
                  let els = [];
                  for (let i = 0; i < q.answers.length; i++) {
                    const answer = q.answers[i];
                    const className = [];
                    if (answer.selected) {
                      className.push(q.isCorrect ? 'correct' : 'wrong');
                    } else if (q.hasAnswered && q.correct === answer.id) {
                      className.push('correct');
                    }
                    els.push({
                      tag: 'label',
                      className: className.join(' '),
                      els: [
                        !q.hasAnswered ? {
                          tag: 'input',
                          type: 'radio',
                          value: answer.id,
                          name: 'answer',
                          onchange: this._onChange
                        } : '',
                        { tag: 'span', text: answer.text },
                      ]
                    });
                  }
                  if (q.hasAnswered) {
                    if (q.count === q.total) {
                      els.push({
                        tag: 'label',
                        className: 'result correct',
                        els: [
                          {
                            tag: 'span',
                            className: 'flex-column',
                            els: [
                              {
                                tag: 'strong',
                                text: `Tu esi atbildējis uz visiem 30 jautājumiem `
                              },
                              {
                                tag: 'div',
                                text: `Kopā esi pareizi atbildējis uz ${q.countCorrect} no 30 jautājumiem.`
                              }
                            ]
                          }
                        ]
                      });
                    } else {
                      els.push({
                        tag: 'label',
                        className: 'result ' + (q.isCorrect ? 'correct' : 'wrong'),
                        els: [
                          {
                            tag: 'span',
                            className: 'flex-column',
                            els: [
                              {
                                tag: 'strong',
                                text: (q.isCorrect ? 'Pareizi!' : 'Nepareizi!')
                              },
                              {
                                tag: 'div',
                                text: q.message
                              }
                            ]
                          }
                        ]
                      });
                    }

                  }
                  return els;
                })()
              },
              !q.hasAnswered ? this._inputSubmit = mkE({
                tag: 'button',
                type: 'submit',
                className: 'button button-pink',
                text: 'IESNIEGT',
                disabled: true,
              }) : '',
            ]
          }
        ]);
      },
      _onChange (e) {
        this._answer = Number(e.currentTarget.value);
        this._inputSubmit.disabled = !(this._answer > 0);
      },
      _onSubmit (e) {
        if (this._inputSubmit.disabled) {
          return;
        }
        this._inputSubmit.disabled = true;
        e.preventDefault();
        this.controller.rpc.send(
          'answer',
          {
            code: this.code,
            answer: this._answer
          },
          this._onLoadQuestion
        );
      }
    },
    ViewBase
  );

  const SectionRtu = Class(
    /**
     * @lends {SectionRtu#}
     */
    {
      route () {
        this.code = this.url.shift();
      },
      __construct () {
        removeClassName(document.body, 'site-b2c');
        addClassName(document.body, 'site-b2b');
        this.node = mkE({
          tag: 'div',
          id: 'SectionRtu',
          className: 'flex-column',
          els: [
            {
              tag: 'div',
              className: 'container logo'
            },
            this.content = mkE({
              tag: 'div',
              className: 'content flex-column'
            })
          ]
        });
      },
      navigateTo (path, par) {
        clearNode(this.content);
        let view;
        switch (path) {
          case 'register':
            view = new ViewRegister(this, par);
            break;
          case 'question':
            view = new ViewQuestion(this, par);
            break;
          case 'closed':
            view = new ViewClosed(this, par);
            break;
          case 'error':
            view = new ViewError(this, par);
            break;
          default:
            view = new ViewIntro(this, par);
            break;
        }
        view.append(this.content);
      },
      draw () {
        this.layout.hideFooter = true;
        this.rpc = new RPC('/api/qrg/rtu_rpc.php');
        this.node.append(this.layout.ct());
        if (this.code) {
          this.navigateTo('question');
        } else {
          this.navigateTo('');
        }
      },
      onLeave () {
        this.layout.hideFooter = false;
      }
    },
    Section
  );

  window.SectionRtu = SectionRtu;

})(window);